import { SignUp } from '@clerk/clerk-react'
import type { ReactNode } from 'react'
import { useState } from 'react'
import { useLocation } from 'react-router-dom'

import { APP_BASE_PATH } from '@/app.const'
import { AUTH_CLERK_APPEARANCE } from '@/components/auth/auth-clerk-appearance.const'
import { AuthLayout } from '@/components/auth/auth-layout.layout'
import { AuthPromoBadge } from '@/components/auth/auth-promo-badge.atom'
import { NewsletterCheckbox } from '@/components/auth/newsletter-checkbox.atom'
import { rootRoutes } from '@/routes/org-routes.const'

export const SignUpPage = (): ReactNode => {
  const location = useLocation()
  const [isNewsletterSubscribed, setIsNewsletterSubscribed] = useState(true)

  const from = (location.state as { from?: string })?.from ?? `${APP_BASE_PATH}/`

  return (
    <AuthLayout
      heading={
        <>
          SEMrush. Ahrefs. Lighthouse.
          <br className="hidden xl:block" /> All included.
        </>
      }
      headerSlot={
        <AuthPromoBadge
          message="Complimentary balance credit waiting for you! No credit card needed 🤑"
          className="mb-6 rotate-[-2deg]"
        />
      }
    >
      <SignUp
        appearance={AUTH_CLERK_APPEARANCE}
        signInUrl={`${APP_BASE_PATH}/${rootRoutes.signIn}`}
        fallbackRedirectUrl={from}
        forceRedirectUrl={from}
        unsafeMetadata={{ isNewsletterSubscribed }}
      />
      <NewsletterCheckbox
        isChecked={isNewsletterSubscribed}
        onCheckedChange={setIsNewsletterSubscribed}
        className="px-10 pb-3"
      />
    </AuthLayout>
  )
}
